"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { Button } from '../../../Button/Button.mjs';
import styles from '../../FileCard.module.scss.mjs';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconClose } from '../../../Icon/components/icons/IconClose.mjs';
import locales from '../../../../../../_virtual/_.locale.json@c33938a00f4bfb40e033ada6b54e38f9.mjs';
import { useLocalizedStringFormatter } from 'react-aria';

const DeleteButton = (props) => {
  const { onDelete } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  return /* @__PURE__ */ jsx(
    Button,
    {
      className: styles.deleteButton,
      "aria-label": stringFormatter.format(`fileCard.delete`),
      variant: "plain",
      color: "secondary",
      onPress: onDelete,
      children: /* @__PURE__ */ jsx(IconClose, {})
    }
  );
};

export { DeleteButton, DeleteButton as default };
//# sourceMappingURL=DeleteButton.mjs.map
